import { useProductSheet } from 'context/product-sheet';
import { useI18n } from 'context/i18n';

// { id: '1', targetId: 'W', name: 'Woman', url: '/es_ES/mujer/zapatos/m/{sku}' },
// { id: '2', targetId: 'M', name: 'Men', url: '/es_ES/hombre/zapatos/m/{sku}' },
const targetOrder = {
  W: 1,
  M: 2,
};

type TargetLinksProps = {
  className?: string;
};
export function TargetLinks({ className }: TargetLinksProps) {
  const { productSheet } = useProductSheet();
  if (!productSheet?.targetLinks || productSheet?.targetLinks.length === 0) return null;
  return (
    <div className={className}>
      {productSheet?.targetLinks.length > 0 && (
        <ol className="mb-0 grid grid-cols-2 gap-px border border-[#DFDFDF] bg-[#DFDFDF] nnormal:gap-0 nnormal:border-dark nnormal:bg-clear">
          {productSheet?.targetLinks
            .sort((a, b) => targetOrder[a.targetId as keyof typeof targetOrder] - targetOrder[b.targetId as keyof typeof targetOrder])
            .map((link, i) => {
              return (
                <li key={`target-link-${link.targetId ?? i}`} className="block h-9 w-full">
                  {link.targetId === productSheet?.realTarget ?
                    <span className="flex h-full w-full items-center justify-center text-xs capitalize text-copy nnormal:bg-neutral-inverted nnormal:text-inverted">
                      {link.name}
                    </span>
                  : <a
                      className="flex h-full w-full items-center justify-center bg-clear text-xs capitalize text-[#919191] transition-colors nnormal:text-copy nnormal:hover:bg-faint camper:hover:bg-[#DFDFDF]"
                      href={link.url}
                    >
                      {link.name}
                    </a>
                  }
                </li>
              );
            })}
        </ol>
      )}
    </div>
  );
}

export function GiftCardTargetLinks({ className }: TargetLinksProps) {
  const { productSheet } = useProductSheet();
  const { t, giftCardList, physicalGiftCardList } = useI18n();
  const isPhysicalGiftCard = physicalGiftCardList.includes(productSheet?.code);
  const isDigitalGiftCard = giftCardList.includes(productSheet?.code);

  const isGiftCard = isPhysicalGiftCard || isDigitalGiftCard;

  if (!isGiftCard) return null;

  const digitalGiftCardLabel = t('ficha.producto', 'gift.card.digital');
  const physicalGiftCardLabel = t('ficha.producto', 'gift.card.physical');
  const [baseUrl] = productSheet.baseUrl.split(productSheet.code);
  const digitalGiftCardUrl = `${baseUrl}${giftCardList[0]}`;
  const physicalGiftCardUrl = `${baseUrl}${physicalGiftCardList[0]}`;

  return (
    <div className={className}>
      <ol className="mb-0 grid grid-cols-2 gap-px border border-[#DFDFDF] bg-[#DFDFDF] nnormal:gap-0 nnormal:border-dark nnormal:bg-clear">
        <li key={`gift-card-target-link-physical`} className="block h-9 w-full">
          {isPhysicalGiftCard ?
            <span className="flex h-full w-full items-center justify-center text-xs capitalize text-copy nnormal:bg-neutral-inverted nnormal:text-inverted">
              {physicalGiftCardLabel}
            </span>
          : <a
              className="flex h-full w-full items-center justify-center bg-clear text-xs capitalize text-[#919191] transition-colors nnormal:text-copy nnormal:hover:bg-faint camper:hover:bg-[#DFDFDF]"
              href={physicalGiftCardUrl}
            >
              {physicalGiftCardLabel}
            </a>
          }
        </li>
        <li key={`gift-card-target-link-online`} className="block h-9 w-full">
          {isDigitalGiftCard ?
            <span className="flex h-full w-full items-center justify-center text-xs capitalize text-copy nnormal:bg-neutral-inverted nnormal:text-inverted">
              {digitalGiftCardLabel}
            </span>
          : <a
              className="flex h-full w-full items-center justify-center bg-clear text-xs capitalize text-[#919191] transition-colors nnormal:text-copy nnormal:hover:bg-faint camper:hover:bg-[#DFDFDF]"
              href={digitalGiftCardUrl}
            >
              {digitalGiftCardLabel}
            </a>
          }
        </li>
      </ol>
    </div>
  );
}
